/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Row, Col } from 'react-bootstrap';
import {
  useForm,
  FieldValues,
  SubmitHandler,
  Controller
} from 'react-hook-form';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { useTranslation } from 'react-i18next';

import Button from 'components/base/Button';
import { showAlert } from 'store/alert/alert.thunk';

interface AddIsForsedQuantityProps {
  setOpenAddProduct: (show: boolean) => void;
  addedProduct?: any;
  selectedData?: any;
  setSelectedData?: any;
}

const AddIsForsedQuantity = ({
  setOpenAddProduct,
  addedProduct,
  setSelectedData
}: AddIsForsedQuantityProps) => {
  const { t } = useTranslation();

  const dispatch: Dispatch<any> = useDispatch();

  const [quantity, setQuantity] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm();

  const inputRefQuantity = useRef<HTMLInputElement | any>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    const measure_unit_pid = addedProduct?.measure_unit_pid;

    // Pattern for integers (e.g., "5", "-5")
    const integerPattern = /^-?\d*$/;
    // Pattern for fractions (e.g., "5/2", "-5/2", allows single slash)
    const fractionPattern = /^-?\d*\/?\d*$/;
    // Pattern for decimal numbers (e.g., "123.45", "-123.45", allows . or ,)
    const decimalPattern = /^-?\d*[.,]?\d*$/;

    if (measure_unit_pid === 1) {
      // Only allow integers, no /, ., or ,
      if (
        integerPattern.test(newValue) &&
        !newValue.includes('.') &&
        !newValue.includes(',') &&
        !newValue.includes('/')
      ) {
        setQuantity(newValue);
      }
    } else if (measure_unit_pid === 7) {
      // Only allow fraction pattern (with /), no . or ,
      if (
        fractionPattern.test(newValue) &&
        !newValue.includes('.') &&
        !newValue.includes(',')
      ) {
        setQuantity(newValue);
      }
    } else {
      // Allow decimal numbers (with . or ,)
      if (decimalPattern.test(newValue)) {
        setQuantity(newValue);
      }
    }
  };

  const onSubmit: SubmitHandler<FieldValues> = data => {
    setLoading(true);

    const quantity = data?.quantity || '0';

    let integerPart = 0;
    let numerator = 0;
    let denominator = 0;

    const quantityStr = String(quantity);

    if (quantityStr?.includes('/')) {
      [numerator, denominator] = quantityStr.split('/').map(Number);

      integerPart = numerator; // Whole number part
      // eslint-disable-next-line
      denominator = denominator; // Remainder of the division
    } else {
      integerPart = +quantityStr;
    }

    const packageQuantity = +addedProduct?.package_quantity || 1;

    // Calculate adjusted quantity
    const adjustedQuantity =
      addedProduct?.measure_unit_kind_pid === 1
        ? integerPart * packageQuantity + denominator
        : integerPart;

    console.log('adjustedQuantity', adjustedQuantity);

    const createdData = {
      ...addedProduct,
      quantity_asked: adjustedQuantity || 0
    };
    setSelectedData((prev: any) =>
      prev.some((item: any) => item?.barcode === createdData?.barcode)
        ? prev.map((item: any) =>
            item?.barcode === createdData?.barcode
              ? { ...item, quantity_asked: createdData?.quantity_asked }
              : item
          )
        : [...prev, createdData]
    );
    dispatch(
      showAlert({
        title: t('product_successfully_added'),
        type: 'success'
      })
    );
    setLoading(false);
    setOpenAddProduct(false);
  };

  useEffect(() => {
    if (inputRefQuantity.current) {
      inputRefQuantity.current.focus();
    }
  }, [inputRefQuantity.current]);

  return (
    <div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="mb-3">
          <Col>
            <Controller
              name={`quantity`}
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Form.Floating className="md-4">
                  <Form.Control
                    {...field}
                    value={quantity}
                    onChange={(e: any) => {
                      handleChange(e);
                      field.onChange(e); // Update react-hook-form state
                    }}
                    ref={inputRefQuantity}
                    type="text"
                    placeholder={t('quantity')}
                    onFocus={e => e.target.select()}
                    isInvalid={!!errors.quantity}
                  />
                  <label htmlFor="floatingInputCustom">{t('quantity')}</label>
                  {errors.quantity && (
                    <Form.Control.Feedback type="invalid">
                      {t('required_field')}
                    </Form.Control.Feedback>
                  )}
                </Form.Floating>
              )}
            />
          </Col>
        </Row>

        <Button
          className="w-100"
          variant="primary"
          type="submit"
          loading={loading}
        >
          {t('add')}
        </Button>
      </Form>
    </div>
  );
};

export default AddIsForsedQuantity;
